import React, { useRef, useState, useEffect } from "react";

interface HorizontalLaneProps {
  children?: React.ReactElement | React.ReactElement[] | string;
}

const HorizontalLane = ({ children }: HorizontalLaneProps) => {
  const laneRef = useRef<HTMLDivElement>(null);
  const [showLeftButton, setShowLeftButton] = useState(false);
  const [showRightButton, setShowRightButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (laneRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = laneRef.current;
        setShowLeftButton(scrollLeft > 0);
        setShowRightButton(scrollLeft + clientWidth < scrollWidth);
      }
    };

    if (laneRef.current) {
      laneRef.current.addEventListener("scroll", handleScroll);
      handleScroll(); // Initial check
    }

    return () => {
      if (laneRef.current) {
        laneRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollLeft = () => {
    if (laneRef.current) {
      laneRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (laneRef.current) {
      laneRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <div className="horizontalLaneContainer">
      {showLeftButton && (
        <button className="scrollButton left" onClick={scrollLeft}>
          &lt;
        </button>
      )}
      <div className="horizontalLane" ref={laneRef}>
        {children}
      </div>
      {showRightButton && (
        <button className="scrollButton right" onClick={scrollRight}>
          &gt;
        </button>
      )}
    </div>
  );
};

export default HorizontalLane;